import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";

import { useEndExperience } from "../../../../api/experience-actions/end-experience";
import { usePauseExperience } from "../../../../api/experience-actions/pause-experience";
import { useStartExperience } from "../../../../api/experience-actions/start-experience";
import { getDialog, setDialog } from "../../../../store/slices/global";

interface MarketUpdateConfirmDialogProps {
  currExperience: ExperienceDto;
}

export const MarketUpdateConfirmDialog = ({
  currExperience,
}: MarketUpdateConfirmDialogProps) => {
  const marketPriceConfirm = useSelector(getDialog("marketUpdateConfirm"));
  const dispatch = useDispatch();

  const startExperience = useStartExperience();
  const endExperience = useEndExperience(true, currExperience.id);
  const pauseExperience = usePauseExperience();

  const closeDialog = () => {
    dispatch(
      setDialog({
        dialog: "marketUpdateConfirm",
        open: false,
        props: { action: "none" },
      })
    );
  };

  const experimentAction = () => {
    if (marketPriceConfirm.props.action === "start") {
      startExperience.mutate({
        pathParams: {
          name: currExperience.name!,
          pausedAtTs: currExperience.pausedAtTs ?? 0,
          experienceId: currExperience.id!,
          action: "start",
        },
        body: {
          updatePricesToVariation: false,
          variationId: undefined,
        },
        queryParams: undefined,
      });
    } else if (marketPriceConfirm.props.action === "pause") {
      pauseExperience.mutate({
        pathParams: {
          name: currExperience.name!,
          experienceId: currExperience.id!,
          action: "pause",
        },
        body: {
          updatePricesToVariation: false,
          variationId: marketPriceConfirm.props.testGroupId,
        },
        queryParams: undefined,
      });
    } else if (marketPriceConfirm.props.action === "end") {
      endExperience.mutate({
        pathParams: {
          name: currExperience.name!,
          experienceId: currExperience.id!,
          action: "end",
        },
        body: {
          updatePricesToVariation: false,
          variationId: marketPriceConfirm.props.testGroupId,
        },
        queryParams: undefined,
      });
    }
    closeDialog();
  };

  return (
    <IgDialog
      showDialog={marketPriceConfirm.isOpen}
      handleYesClick={experimentAction}
      handleClose={closeDialog}
      title={"Have you uploaded your prices to Shopify Markets or Global-e?"}
      yesButtonText={`Yes, ${marketPriceConfirm.props.action} the test.`}
      dialogHeight={"auto"}
    />
  );
};
